import { useCallback } from 'react';
import {
	EntryKeys,
	ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB,
} from '@atlassian/jira-feedback-collector/src/constants.tsx';
import { useFeedbackCollectorActions } from '@atlassian/jira-feedback-collector/src/controllers/index.tsx';
import type { FeedbackCollectorProps } from '@atlassian/jira-feedback-collector/src/types.tsx';

export const FEEDBACK_GROUP_ID = 'jsm-insight-new-object-view';

export const OBJECT_VIEW_LOCATION = 'new-insight-object-view';
export const SCHEMA_PAGE_LOCATION = 'new-schema-page-view';
export const GETTING_STARTED_LOCATION = 'cmdb-getting-started';

type FeedbackCollectorLocations =
	| typeof OBJECT_VIEW_LOCATION
	| typeof SCHEMA_PAGE_LOCATION
	| typeof GETTING_STARTED_LOCATION;

export const useInsightFeedbackCollector = (location: FeedbackCollectorLocations) => {
	const { openFeedbackCollector } = useFeedbackCollectorActions();

	const openFeedbackDialog = useCallback(
		(options?: Partial<FeedbackCollectorProps>) => {
			openFeedbackCollector({
				feedbackGroupId: FEEDBACK_GROUP_ID,
				entrypointId: ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB,
				...options,
				feedbackContext: [
					{
						id: EntryKeys.FEEDBACK_COLLECTOR_LOCATION,
						value: location,
					},
					...(options?.feedbackContext ?? []),
				],
			});
		},
		[location, openFeedbackCollector],
	);

	return { openFeedbackDialog };
};
